export default __webpack_public_path__ + "static/media/plus-circle.1931b4df.svg";